/*
 * @Description: 公共部分请求
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-22 14:55:05
 * @LastEditTime: 2019-07-26 22:40:28
 */

import { logistice, authorization } from '@/utils/request'
import { LOGISTICE_GATEWAY, LOGISTICE_BASEAPI, AUTHORIZATION_GATEWAY, AUTHORIZATION_BASEAPI } from '@/utils/settings' // 请求接口

/* 获取地址接口 */
const getAreaUrl = `${LOGISTICE_GATEWAY}/sys/sysArea/find`

/* 查询字典接口 */
const getDictUrl = `${LOGISTICE_GATEWAY}/sys/dict/getDict`

/* 查询当前用户认证状态的地址 */
const getiDentificateUrl = `${LOGISTICE_GATEWAY}/website/index/systemUser`
/* 查询级联地址 */
export const getArea = () => {
  return logistice.post(getAreaUrl, undefined, { params: { params: { methodName: 'findTreeData' }}})
}

/* 查询字典 */
export const getDict = (type) => {
  return logistice.post(getDictUrl, undefined, { params: {
    params: { methodName: 'getListByType',
      type: type,
      hasAll: 'no' }
  }})
}
/** 查询当前用户认证状态 */
export const getiDentificate = (userId) => {
  return logistice.post(getiDentificateUrl, undefined, {
    params: {
      params: {
        methodName: 'userAuthStatus', userId: userId
      }
    }
  })
}

/* 下载 */
export const download = `${LOGISTICE_BASEAPI}${LOGISTICE_GATEWAY}/youThing/likeSomething?params=`

/* 上传 */
export const upload = ({ data, methodName }, { onUploadProgress }) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/youThing/loveSomething`,
    method: 'post',
    data,
    onUploadProgress, // 获取上传进度
    params: {
      params: JSON.stringify(Object.assign({ methodName: methodName }))
    }
  })
}

/* 删除 */
export const delImg = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/youThing/coolSomething`,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({ methodName: 'deleteFile' }, params))
    }
  })
}

/* 获取手机验证码 */
export const getPhoneCode = (params) => {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/systemUser`,
    method: 'post',
    data: Object.assign({ methodName: 'createSmsCode' }, params)
  })
}

/* 获取登录手机验证码 */
export const getPhoneCodeLogin = (params) => {
  return authorization({
    url: `${AUTHORIZATION_GATEWAY}/admin/mobile/${params}`,
    method: 'get'
  })
}
// 获取图形验证码
export const codeUrl = `${AUTHORIZATION_BASEAPI}${AUTHORIZATION_GATEWAY}/code`
